import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TbReportAnalytics } from "react-icons/tb";
import { LuMedal } from "react-icons/lu";
import { IoSpeedometerOutline } from "react-icons/io5";
import { GrDocumentUpload } from "react-icons/gr";
import { TbFilePencil, TbReport } from "react-icons/tb";
const PrincipleMenu = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        onClick={() => navigate("/PrincipleDashboard")}
        className={
          !props.CheckPath("/PrincipleDashboard")
            ? "TabNotSelect"
            : "SubTabSelect"
        }
      >
        <IoSpeedometerOutline /> Dashboard{" "}
      </div>

      <div
        onClick={() =>
          navigate("/TeacherDashboard/StudentInformation/StudentDetails", {
            replace: true,
          })
        }
        className={
          props.CheckPath("StudentDetails") ? "SubTabSelect" : "TabNotSelect"
        }
      >
        <TbFilePencil /> Registrations{" "}
      </div>

      <div
        onClick={() =>
          navigate("/TeacherDashboard/StudentInformation/AutobulkRegistrations")
        }
        className={
          props.CheckPath(
            "/TeacherDashboard/StudentInformation/AutobulkRegistrations",
          )
            ? "SubTabSelect"
            : "TabNotSelect"
        }
      >
        <GrDocumentUpload /> Bulk Registrations{" "}
      </div>

      {/* <div onClick={() => navigate("/PrinciplePerformance")}
                className={props.CheckPath("/PrincipleDashboard") || props.CheckPath("/PrincipleParticipation") ||
                    props.CheckPath("StudentInformation") || props.CheckPath("/ViewAnswerSheet") ||
                    props.CheckPath("/LoPerformanceReport") ||
                    props.CheckPath("/LoPerformance") || props.CheckPath("/PrincipleReportCard")
                    ? "TabNotSelect" : "SubTabSelect"} >
                <IoSpeedometerOutline /> Performance </div> */}

      <div
        onClick={() => navigate("/PrinciplePerformance")}
        className={
          props.CheckPath("/PrinciplePerformance") ||
          (props.CheckPath("/TeacherDashboard") &&
            !props.CheckPath("/StudentInformation"))
            ? "SubTabSelect"
            : "TabNotSelect"
        }
      >
        <IoSpeedometerOutline /> Performance{" "}
      </div>

      <div
        onClick={() => navigate("/PrincipleParticipation")}
        className={
          props.CheckPath("/PrincipleParticipation")
            ? "SubTabSelect"
            : "TabNotSelect"
        }
      >
        <LuMedal /> Participation{" "}
      </div>

      <div
        onClick={() =>
          navigate(
            "/TeacherDashboard/StudentInformation/Results/AssessmentResults",
          )
        }
        className={
          props.CheckPath("/Results") ||
          props.CheckPath("/ViewAnswerSheet") ||
          props.CheckPath("/LoPerformanceReport") ||
          props.CheckPath("/Samagra/LoPerformance")
            ? "SubTabSelect"
            : "TabNotSelect"
        }
      >
        <TbReportAnalytics /> Results{" "}
      </div>

      <div
        onClick={() => navigate("/Principle/PrincipleReportCard")}
        className={
          props.CheckPath("/PrincipleReportCard")
            ? "SubTabSelect"
            : "TabNotSelect"
        }
      >
        <TbReport /> Report Cards{" "}
      </div>
    </>
  );
};
export default PrincipleMenu;
